import {
    Box,
    Button,
    Container,
    Paper,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Config from "Config";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import Header from "../../../component/Header/Header";
import PortalNavbar from "../../../component/PortalNavbar/PortalNavbar";
import { send } from "../../../SendRequest";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
});

function Authentication() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();

    const handleLogin = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/iamsmart/auth`,
            method: "POST",
        };
        dispatch(send("IAMSMART_AUTH", option))
            .then((res) => res.json())
            .then((result) => {
                console.log("Auth Data:" + result);
            });
    };

    const handleFormFill = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/iamsmart/profile`,
            method: "POST",
        };
        dispatch(send("IAMSMART_PROFILE", option))
            .then((res) => res.json())
            .then((result) => {
                console.log("Form Fill Data:" + result);
            });
    };

    const handleSign = () => {
        const option = {
            url: `${Config.CONTENT_PATH}/iamsmart/sign`,
            method: "POST",
        };
        dispatch(send("IAMSMART_SIGN", option))
            .then((res) => res.json())
            .then((result) => {
                console.log("Signning Data:" + result);
            });
    };

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={"iAM Smart 智方便"}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <main Box className="main">
                    <Paper>
                        <Typography>
                            Hello! This is iAM Smart Authentication Page!
                            <br></br>
                            You can use iAM Smart to:
                        </Typography>
                        <br></br>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleLogin}
                        >
                            Login
                        </Button>
                        <br />
                        <br />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleFormFill}
                        >
                            Click to auto-fill your information
                        </Button>
                        <br />
                        <br />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSign}
                        >
                            Digital Signning
                        </Button>
                    </Paper>
                </main>
            </Box>
        </Container>
    );
}
export default Authentication;
